module.exports = __webpack_public_path__ + "static/media/fish-tank-dirty.39112e9f.png";